module.exports = __webpack_public_path__ + "static/sefa-celik-672b25a65f4453c02592239eaeac6c99.png";